import { DjangoFactory } from './django-factory';

export class DjangoModel {
    automaticDeserializeFields: string[] = [];

    deserialize(input: any) {
        if (input) {
            const deserialized = DjangoFactory.deserialize(
                input,
                this.automaticDeserializeFields
            );
            Object.assign(this, deserialized);
        }
    }
}
